define('shared/initializer/form/adapters/mixins/UpdateMemberInfoInPaymentPage',[
    'shared/initializer/form/constants',
    '$',
    'shared/lib/RSVP',
    'shared/lib/console',
    'shared/my/identity',
    'shared/my/cmus',
    'shared/util/fields/Telephone'
],
function (
    constants, 
    $, 
    RSVP, 
    console, 
    getIdentity, 
    getCMus,
    TelephoneUtil
) {

    'use strict';

    function Ctor() { }

    Ctor.prototype.doBeforeSubmit = function(){
        var me = this;

        var memberId = -1;
        var cmus = '';

        return RSVP.all([getIdentity(), getCMus()])
            .then(function(values){
                memberId = values[0];
                cmus = values[1];
            })
            .then(function(){
                if(!memberId || memberId < 0 || !cmus){
                    return RSVP.resolve();
                }

                var fieldPhone = me.items.get(constants.FIELD.PHONE);
                var fieldPhoneType =  me.items.get(constants.FIELD.PHONE_TYPE);
                var fieldState =  me.items.get(constants.FIELD.LOCATION_STATE);
                var fieldCity =  me.items.get(constants.FIELD.LOCATION_CITY);

                var homePhone = '';
                var mobilePhone = '';
                if(fieldPhone && fieldPhone.$el){
                    homePhone = fieldPhone.$el.val();
                    if(
                        fieldPhoneType && 
                        TelephoneUtil.getCurrentPhoneType(fieldPhoneType.$el) == constants.PhoneType.Mobile) {
                        homePhone = '';
                        mobilePhone = fieldPhone.$el.val();
                    }
                }

                var stateCode = (fieldState && fieldState.$el) ? fieldState.$el.val() : '';
                var cityCode = (fieldCity && fieldCity.$el) ? fieldCity.$el.val() : '';

                if(homePhone === '' && mobilePhone === '' && stateCode === '' && cityCode === ''){
                    return RSVP.resolve();
                }

                return new RSVP.Promise(function(resolve, reject){
                    var data = {
                        'member.Member_id': memberId,
                        'member.StateCode': stateCode,
                        'member.CityCode': cityCode,
                        'member.HomePhone': homePhone,
                        'member.MobilePhone': mobilePhone,
                        cmus: cmus
                    };
                    console.log('update member with data: ', data);
                    var dfd = $.ajax({
                        url: constants.ServiceUrl.UpdateMember,
                        type: 'POST',
                        data: data,
                        dataType: 'json'
                    });
                    dfd.then(
                        function(memberUpdateReturn){
                            if(
                                memberUpdateReturn && 
                                memberUpdateReturn.Success && 
                                memberUpdateReturn.Result && 
                                memberUpdateReturn.Result.Success
                            ){
                                console.log('update member succeeded.');
                                resolve();
                            }
                            else{
                                console.log('update member failed with result: ', memberUpdateReturn);
                                reject();
                            }
                        },
                        reject);
                });
            });
    };

    return Ctor;
});

